import { apiClient } from '../client';

/**
 * Client for `/api/eos/headlines/*`. Stays in lockstep with
 * `server/src/routes/eos/headlines.routes.ts` (Stream B Wave 2, ADR-023).
 */

export interface Headline {
  id: string;
  organizationId: string;
  title: string;
  /** Null until shared in a meeting — headlines can be queued ahead. */
  meetingId: string | null;
  departmentId: string | null;
  authorMembershipId: string | null;
  archivedAt: string | null;
  createdAt: string;
}

export interface ListHeadlinesQuery {
  departmentId?: string;
}

export async function listHeadlines(q: ListHeadlinesQuery = {}): Promise<Headline[]> {
  const params = new URLSearchParams();
  if (q.departmentId) params.set('departmentId', q.departmentId);
  const query = params.toString() ? `?${params.toString()}` : '';
  const res = await apiClient.get<{ data: Headline[] }>(`/api/eos/headlines${query}`);
  return res.data.data;
}

export interface CreateHeadlineRequest {
  title: string;
  departmentId?: string;
  meetingId?: string;
}

export async function createHeadline(body: CreateHeadlineRequest): Promise<Headline> {
  const res = await apiClient.post<{ data: Headline }>('/api/eos/headlines', body);
  return res.data.data;
}

/** Soft delete — author or superadmin only (server-enforced). */
export async function archiveHeadline(id: string): Promise<void> {
  await apiClient.delete(`/api/eos/headlines/${encodeURIComponent(id)}`);
}
